<template>
	<div>
		<div class="subscribeVideo" :class="{ toggled: expandVid.value }">
			<div ref="subscribe-video" />
			<div
				v-if="!isClient"
				class="expandIcon"
				@click="toggleVideo"
			/>
			<div class="nameContainer">
				<template v-if="isClient">
					<span class="notaryName">{{ notaryName.value }}</span>
					<span>Notary</span>
				</template>
			</div>
		</div>
		<div class="selfVideo">
			<div ref="self-video" />
			<div
				v-if="openTokSelfStreamReady.value === true"
				class="muteButton"
				:class="{ muted: isMuted.value }"
				@click="toggleMute"
			/>			
		</div>

		<signers-list
			:signers="principalSigners"
			header="Principal Signers"
			class="signer"
			:show-view-id="!isClient"
			:start-expanded="true"
		/>
		<signers-list
			v-if="witnesses?.length > 0"
			:signers="witnesses"
			header="Witnesses"
			class="witness"
		/>
		<task-counter v-if="showTaskCount">
			<button v-if="!isClient" class="endCall" @click="$emit(`endCall`)">
				End Call
			</button>
		</task-counter>
	</div>	
</template>

<script>
import { mapGetters } from "vuex";
import SignersList from "./SignersList.vue";
import TaskCounter from "./TaskCounter.vue";

export default {
	components: { SignersList, TaskCounter },	
	inject: {
		notaryName: { type: String },
		openTokSelfStreamReady: { type: Boolean },
		subscribeSelfStream: { type: Function },
		openTokClientStreamReady: { type: Boolean },
		subscribeClientStream: { type: Function },
		isMuted: { type: Boolean },
		toggleMute: { type: Function },
		expandVid: { type: Boolean },
		toggleVideo: { type: Function },
		changeSubscribeTasksCount: { type: Function }
	},
	props: {
		isClient: { type: Boolean, default: true },
		showTaskCount: { type: Boolean, default: true }
	},
	emits: [`endCall`],
	computed: {
		...mapGetters(`Signers`, [`principalSigners`, `witnesses`]),
	},
	watch: {
		'openTokSelfStreamReady.value': {
			handler() {
				this.subscribeSelf();
			},
			flush: `post`,
			immediate: true
		},
		'openTokClientStreamReady.value': {
			handler() {
				this.subscribeClient();
			},
			flush: `post`,
			immediate: true
		}
	},
	beforeMount() {
		this.changeSubscribeTasksCount();
	},
	unmounted() {
		this.changeSubscribeTasksCount(-1);
	},
	methods: {
		subscribeSelf() {
			if (this.openTokSelfStreamReady.value) {
				this.subscribeSelfStream(this.$refs[`self-video`]);
			}
		},
		subscribeClient() {
			if (this.openTokClientStreamReady.value) {
				this.subscribeClientStream(this.$refs[`subscribe-video`]);
			}
		}
	},
};
</script>